define('StockInformation.Model',
  [
    'SCModel',
    'Utils'
  ],
  function (
    SCModelComponent,
    Utils
  ) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    function StockInformationModel() {
      SCModel.call(this);

      this.urlRoot = function urlRoot() {
        return Utils.getAbsoluteUrl(
          getExtensionAssetsPath('Modules/StockInformation/SuiteScript2/StockInformation.Service.ss'),
          true
        );
      };

    }
    StockInformationModel.prototype = Object.create(SCModel.prototype);

    StockInformationModel.prototype.constructor = StockInformationModel;

    return StockInformationModel;
  });
